import { useDoubleClick } from "./useDoubleClick.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useDoubleClick
};
//# sourceMappingURL=index.js.map
